const translations = {
  en_GB: {
    EMAIL: 'Email',
    LOGGED_OUT_MESSAGE: 'Please login to view account details',
    PRIVACY_POLICY: 'Privacy Policy',
    TERMS_AND_CONDITIONS: 'Terms and Conditions',
    TOS_LINE_1: 'The personal information you provide will be processed in line with our',
    TOS_LINE_2: 'By using our website, you agree to our',
    GENERIC_VALIDATION_MESSAGE: 'Required field',
    EMAIL_VALIDATION_MESSAGE: 'Please enter a valid email',
    PASSWORD_VALIDATION_MESSAGE:
      'Must contain 8 or more characters with a mix of upper & lower case letters, numbers & symbols and no spaces',
    PASSWORD_CONFIRM_VALIDATION_MESSAGE: 'Password must match',
    TOC_VALIDATION_MESSAGE: 'Please agree to our terms and conditions',
    YOUR_LOGIN: 'Your Login',
    YOUR_DETAILS: 'Your details',
    BILLING_ADDRESS: 'Billing Address',
    CONTINUE: 'Continue',
    PASSWORD: 'Password',
    CONFIRM_PASSWORD: 'Confirm password',
    TITLE: 'Title',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    JOB_TITLE: 'Job Title',
    COMPANY_NAME: 'Company Name',
    TELEPHONE: 'Telephone',
    INDUSTRY: 'Industry',
    ADDRESS_LINE_1: 'Address Line 1',
    ADDRESS_LINE_2: 'Address Line 2',
    CITY_TOWN: 'City/Town',
    POSTCODE: 'Post code / Zip',
    COUNTRY: 'Country',
    COUNTY: 'County / State',
    REGISTER: 'Register',
    USER_DETAILS_UPDATED: 'User details updated',
    UPDATE: 'Update',
    PLEASE_CHOOSE: 'Please choose',
    TITLE_OPTIONS: 'Miss,Mr,Mrs,Ms'
  },
  en_US: {},
  fr_FR: {
    EMAIL: 'Courriel',
    LOGGED_OUT_MESSAGE: 'Veuillez vous connecter pour voir les détails du compte',
    PRIVACY_POLICY: 'politique sur la vie privée',
    TERMS_AND_CONDITIONS: 'Termes et conditions',
    TOS_LINE_1: 'Vos données personnelles seront sujettes à notre',
    TOS_LINE_2: 'En utilisant notre site web vous acceptez nos',
    GENERIC_VALIDATION_MESSAGE: 'Champ requis',
    EMAIL_VALIDATION_MESSAGE: 'Entrer un courriel valide',
    PASSWORD_VALIDATION_MESSAGE:
      'Doit contenir au minimum 8 caractères avec un mélange de minuscules et majuscules, nombres et symboles sans espaces',
    PASSWORD_CONFIRM_VALIDATION_MESSAGE: 'Les Mots de Passe doivent être identiques',
    TOC_VALIDATION_MESSAGE: 'Accepter nos Termes et Conditions',
    YOUR_LOGIN: 'Votre Login',
    YOUR_DETAILS: 'Vos détails',
    BILLING_ADDRESS: 'Adresse de Facturation',
    CONTINUE: 'Continuer',
    PASSWORD: 'Mot de Passe',
    CONFIRM_PASSWORD: 'Confirmer votre Mot de Passe',
    TITLE: 'Titre',
    FIRST_NAME: 'Prénom',
    LAST_NAME: 'Nom',
    JOB_TITLE: 'Fonction',
    COMPANY_NAME: 'Nom de la Société',
    TELEPHONE: 'Téléphone',
    INDUSTRY: 'Industrie',
    ADDRESS_LINE_1: 'Adresse ligne 1',
    ADDRESS_LINE_2: 'Adresse ligne 2',
    CITY_TOWN: 'Ville',
    POSTCODE: 'Code Postal',
    COUNTRY: 'Pays',
    COUNTY: 'Pays',
    REGISTER: "S'enregister",
    USER_DETAILS_UPDATED: 'Détails utilisateurs remis à jour',
    UPDATE: 'Mise à jour',
    PLEASE_CHOOSE: 'Choisissez',
    TITLE_OPTIONS: 'Mle, Mme, Mr'
  },
  it_IT: {
    EMAIL: 'Email',
    LOGGED_OUT_MESSAGE: "Effettua il login per visualizzare i dettagli dell'account",
    PRIVACY_POLICY: 'Informativa sulla privacy',
    TERMS_AND_CONDITIONS: 'Termini e Condizioni',
    TOS_LINE_1: 'Le informazioni personali fornite verranno trattate in linea con la nostra',
    TOS_LINE_2: 'Utilizzando il nostro sito web, accetti i nostri',
    GENERIC_VALIDATION_MESSAGE: 'Campo obbligatorio',
    EMAIL_VALIDATION_MESSAGE: 'Inserisci un email valida',
    PASSWORD_VALIDATION_MESSAGE:
      'Deve contenere 8 o più caratteri con un mix di lettere maiuscole e minuscole, numeri e simboli e senza spazi',
    PASSWORD_CONFIRM_VALIDATION_MESSAGE: 'La password deve corrispondere',
    TOC_VALIDATION_MESSAGE: 'Si prega di accettare i nostri termini e condizioni',
    YOUR_LOGIN: 'Il tuo accesso',
    YOUR_DETAILS: 'I tuoi dettagli',
    BILLING_ADDRESS: 'Indirizzo fatturazione',
    CONTINUE: 'Continua',
    PASSWORD: 'Password',
    CONFIRM_PASSWORD: 'Conferma password',
    TITLE: 'Titolo',
    FIRST_NAME: 'Nome',
    LAST_NAME: 'Cognome',
    JOB_TITLE: 'Titolo del lavoro',
    COMPANY_NAME: 'Nome azienda',
    TELEPHONE: 'Telefono',
    INDUSTRY: 'Industria',
    ADDRESS_LINE_1: 'Indirizzo linea 1',
    ADDRESS_LINE_2: 'Indirizzo linea 2',
    CITY_TOWN: 'Città',
    POSTCODE: 'Cap',
    COUNTRY: 'Paese',
    COUNTY: 'Provincia',
    REGISTER: 'Registrati',
    USER_DETAILS_UPDATED: 'Dati utente aggiornati',
    UPDATE: 'Aggiorna',
    PLEASE_CHOOSE: 'Per favore scegli',
    TITLE_OPTIONS: 'Sig. Na, Sig. Ra, Sig.'
  },
  de_DE: {
    EMAIL: 'Email-Adresse',
    LOGGED_OUT_MESSAGE: 'Zum Anzeigen der Kontoeinstellungen bitte einloggen',
    PRIVACY_POLICY: 'Datenschutzrichtlinie',
    TERMS_AND_CONDITIONS: 'Geschäftsbedingungen einverstanden',
    TOS_LINE_1: 'Die von Ihnen bereitgestellten persönlichen Informationen werden gemäß unseren',
    TOS_LINE_2:
      'verarbeitet. Durch die Nutzung unserer Website erklären Sie sich mit unseren Allgemeinen',
    GENERIC_VALIDATION_MESSAGE: 'Pflichtfeld',
    EMAIL_VALIDATION_MESSAGE: 'Bitte tragen Sie eine gültige Email ein',
    PASSWORD_VALIDATION_MESSAGE:
      'Muss 8 oder mehr Zeichen bestehend aus Groß- und Kleinbuchstaben, Zahlen und Symbolen und ohne Leerzeichen enthalten',
    PASSWORD_CONFIRM_VALIDATION_MESSAGE: 'Passwörter müssen übereinstimmen',
    TOC_VALIDATION_MESSAGE: 'Bitte stimmen Sie unseren Allgemeinen Geschäftsbedingungen zu',
    YOUR_LOGIN: 'Ihre Anmeldung',
    YOUR_DETAILS: 'Ihre Angaben',
    BILLING_ADDRESS: 'Rechnungsadresse',
    CONTINUE: 'Weiter',
    PASSWORD: 'Passwort',
    CONFIRM_PASSWORD: 'Passwort bestätigen',
    TITLE: 'Titel',
    FIRST_NAME: 'Vorname',
    LAST_NAME: 'Nachname',
    JOB_TITLE: 'Position',
    COMPANY_NAME: 'Firmenname',
    TELEPHONE: 'Telefon',
    INDUSTRY: 'Branche',
    ADDRESS_LINE_1: 'Adresse 1',
    ADDRESS_LINE_2: 'Adresse 2',
    CITY_TOWN: 'Stadt',
    POSTCODE: 'Postleitzahl',
    COUNTRY: 'Staat',
    COUNTY: 'Bundesland',
    REGISTER: 'Registrieren',
    USER_DETAILS_UPDATED: 'Nutzerdetails aktualisiert',
    UPDATE: 'Aktualisierung',
    PLEASE_CHOOSE: 'Bitte wählen',
    TITLE_OPTIONS: 'Frau, Herr, Divers'
  }
};

export default translations;

export const overrideTranslations = {
  'page-builder-fe': {
    en_GB: {
      SEARCH_MOBILE_BUTTON_TEXT: 'Find Parts',
      SEARCH_BUTTON_TEXT: 'Find Parts'
    },
    en_US: {},
    fr_FR: {
      SEARCH_MOBILE_BUTTON_TEXT: 'Trouver Pièces',
      SEARCH_BUTTON_TEXT: 'Trouver Pièces'
    },
    it_IT: {
      SEARCH_MOBILE_BUTTON_TEXT: 'Trova le Parti',
      SEARCH_BUTTON_TEXT: 'Trova le Parti'
    },
    de_DE: {
      SEARCH_MOBILE_BUTTON_TEXT: 'Teile Finden',
      SEARCH_BUTTON_TEXT: 'Teile Finden'
    }
  }
};
